import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  "fit-width": "true",
  "transition-duration": "0s",
  "item-selector": ".card_box",
  gutter: "10",
  class: "short_video"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "tag"
}
const _hoisted_5 = { class: "Lottie_color" }
const _hoisted_6 = { class: "announcing_text" }
const _hoisted_7 = { class: "announcing_text" }
const _hoisted_8 = { class: "card_introduction" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "with_title" }
const _hoisted_11 = { class: "playback_box name_width" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "playback_box playback_width" }
const _hoisted_14 = { class: "playback" }

import { computed, getCurrentInstance, nextTick, ref, watch } from 'vue'
import { Image as VanImage, showToast } from 'vant'
import { useRouter } from 'vue-router'
import { Record } from '@/api/Models/CommunityBoardContentList'
import { screenWidth } from '@/utils'
import { useVideoStore } from '@/stores/video'
import { loading } from '@/utils/loading'
import { useComponentStore } from '@/stores/components'
import { storeToRefs } from 'pinia'
import LottieFlow from './LottieFlow.vue'
import { useI18n } from 'vue-i18n'

export default /*@__PURE__*/_defineComponent({
  __name: 'ShortVideo',
  props: {
    articleData: {},
    active: {}
  },
  setup(__props: any) {

const router = useRouter()
const newWidth = (screenWidth - 42) / 2
const { t } = useI18n()
const defaultPhoto = require('@/assets/images/defalut_short_video.png')

const props = __props

const videoStore = useVideoStore()
const list = ref<Record[]>(props.articleData)

const newFlag = ref<boolean>(true)

const filterImg = computed(() => (item: { status?: number; coverUrl?: string }) => {
  if (item?.status === 3) {
    if (item?.coverUrl) {
      return item?.coverUrl
    } else {
      return defaultPhoto
    }
  } else {
    return defaultPhoto
  }
})

const goDetail = (item: Record) => {
  if (+item.attachments[0]?.status === 3) {
    // 转码成功
    videoStore.setFirstVideoData(item)
    const componentsStore = useComponentStore()
    const { includeComponents } = storeToRefs(componentsStore)
    if (!includeComponents.value.includes('communityDetail')) {
      componentsStore.setIncludeComponents([...includeComponents.value, 'communityDetail'])
    }
    router.push({
      path: '/rollVideo',
      query: {
        sortType: props.active,
        boardId: item.boardId,
        id: item.id
      }
    })
  } else {
    showToast(t('video_processing_h5'))
  }
}

const that = getCurrentInstance()?.appContext.config.globalProperties
watch(
  props,
  (newData) => {
    list.value = newData.articleData
    list.value.forEach((e: Record) => {
      if (e?.attachments && e?.attachments[0]) {
        const num = e?.attachments[0]?.expandInfo ? JSON.parse(e?.attachments[0]?.expandInfo) : 168
        if (e?.attachments[0]?.coverUrl) {
          if (num.videoWidth > num.videoHeight) {
            e.height = Math.floor((newWidth / 4) * 3) + 'px'
          } else {
            e.height = Math.floor((newWidth / 3) * 4) + 'px'
          }
        } else {
          e.height = Math.floor((newWidth / 3) * 4) + 'px'
        }
      }
    })
    that?.$redrawVueMasonry()
  },
  {
    immediate: true,
    deep: true
  }
)

const isFlag = () => {
  return (newFlag.value = true)
}

watch(
  () => props.active,
  () => {
    loading.show()
    newFlag.value = false
    nextTick(() => {
      setTimeout(isFlag, 1000)
    })
    setTimeout(() => {
      loading.hide()
    }, 1100)
  }
)


return (_ctx: any,_cache: any) => {
  const _directive_masonry_tile = _resolveDirective("masonry-tile")!
  const _directive_masonry = _resolveDirective("masonry")!

  return (newFlag.value)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (goDetail(item)),
            class: "card_box",
            style: _normalizeStyle({ width: newWidth + 'px' })
          }, [
            (item?.attachments[0] && item?.attachments[0].status === 3)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "head_img",
                  style: _normalizeStyle({ height: item?.height, width: newWidth + 'px' })
                }, [
                  _createElementVNode("img", {
                    src: filterImg.value(item?.attachments[0]),
                    alt: "''"
                  }, null, 8, _hoisted_3),
                  (item?.boardToppingStatus === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('pc_community_top')), 1))
                    : _createCommentVNode("", true),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "play_button" }, [
                    _createElementVNode("i", { class: "iconfont icon-icon_shequzhongxin_bofang" })
                  ], -1))
                ], 4))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "head_bg",
                  style: _normalizeStyle({ height: item?.height, width: newWidth + 'px' })
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(LottieFlow)
                  ]),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('under_release_h5')), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('video_refresh_h5')), 1)
                ], 4)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(VanImage), {
                    width: "16px",
                    height: "16px",
                    src: item.avatarFileUrl,
                    class: "avatar",
                    round: ""
                  }, null, 8, ["src"]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.createByName), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "iconfont icon-icon_shequzhongxin_bofang" }, null, -1)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.viewCount), 1)
                ])
              ])
            ])
          ], 12, _hoisted_2)), [
            [_directive_masonry_tile]
          ])
        }), 128))
      ])), [
        [_directive_masonry]
      ])
    : _createCommentVNode("", true)
}
}

})